/* eslint-disable react/no-danger */
/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { renderHTMLContent } from '@components/ComparisonTable/helper'
import styles from './valueCompareGrid.module.scss'

const CardCompare = ({ data }) => {
  const { title, image, previousLabel, updatedLabel, previousValue, UpdatedValue } = data
  const imageUrl = image?.data?.attributes?.url

  return (
    <div className={styles.cardCompareContainer}>
      <img src={imageUrl} alt={title} className={styles.cardImage} />
      {/* Card content */}
      <div className={styles.contentSection}>
        <h3 className={styles.cardHeading}>{title}</h3>
        <p className={styles.label} style={{ marginTop: '16px' }}>
          {previousLabel}
        </p>
        <div className={styles.htmlValue}>
          <span dangerouslySetInnerHTML={{ __html: renderHTMLContent(previousValue) }} />
        </div>
        <div className={styles.cardDivider} />
        <p className={styles.label}>{updatedLabel}</p>
        <div className={styles.htmlValue}>
          <span dangerouslySetInnerHTML={{ __html: renderHTMLContent(UpdatedValue) }} />
        </div>
      </div>
    </div>
  )
}

export default CardCompare
